import React from "react";
import { Skeleton } from "../../Skeleton/Skeleton";
import ArrowRightIcon from "../../../icons/ArrowRightIcon";

export const OfferCardPlaceholder = ({ className }) => (
  <div
    className={`tbk-bg-white tbk-overflow-hidden tbk-rounded-xl tbk-shadow-trube ${className}`}
  >
    <Skeleton className="tbk-flex tbk-h-40 tbk-items-center tbk-justify-center tbk-bg-blue-grey-light" />
    <div className="tbk-flex tbk-items-center tbk-space-x-2 tbk-p-1">
      <Skeleton className="tbk-h-7 tbk-w-7 tbk-rounded-lg tbk-bg-blue-grey-light" />
      <div className="!tbk-mr-4 tbk-grow">
        <Skeleton className="tbk-mb-0.5 tbk-h-[30px] tbk-rounded-2xl tbk-bg-blue-grey-light" />
        <Skeleton className=" tbk-bg-white tbk-mr-6 tbk-flex tbk-h-[18px] tbk-flex-1 tbk-grow tbk-space-x-0.5 tbk-rounded-lg tbk-border tbk-border-blue-grey-light" />
      </div>
      <ArrowRightIcon className="tbk-ml-5 tbk-text-blue-grey-light" />
    </div>

    {/*<div className="tbk-px-6 tbk-pt-4 tbk-pb-2">
      <span className="tbk-inline-block tbk-bg-gray-300 tbk-rounded-full tbk-px-3 tbk-py-1 text-sm font-semibold text-gray-700 tbk-mr-2 tbk-mb-2"></span>
      <span className="tbk-inline-block tbk-bg-gray-300 tbk-rounded-full tbk-px-3 tbk-py-1 text-sm font-semibold text-gray-700 tbk-mr-2 tbk-mb-2"></span>
    </div>*/}
  </div>
);

export default OfferCardPlaceholder;
